/* The receipt as a vertical chain (docs/design/36-user-journeys.md section 5).

   One node per link, a rail between them. The rail is drawn by each node's own `::before`, running
   from its marker down to the next node, so a missing link can break the line it sits on: its rail
   is dashed and the card carries a border. Status is never colour alone - every node also has its
   icon and its word. Colours are tokens; nothing here is a literal. */

.chainWrap {
  margin-top: 4px;
}

.intro {
  font-size: var(--t-min);
  color: var(--muted);
  margin: 0 0 8px;
  line-height: 1.45;
}

.rail {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.node {
  --rail-x: 10px;
  position: relative;
  padding: 0 0 12px 34px;
  min-width: 0;
}

/* The line to the next node. Not drawn for the last one. */
.node::before {
  content: "";
  position: absolute;
  left: calc(var(--rail-x) - 1px);
  top: 24px;
  bottom: -2px;
  border-left: 2px solid var(--line-2);
}

.node:last-child {
  padding-bottom: 0;
}

.node:last-child::before {
  display: none;
}

/* A visible break: the rail below a missing link is dashed and warm, so the trail is seen to stop. */
.node[data-standing="missing"]::before {
  border-left: 2px dashed var(--warn);
}

.marker {
  position: absolute;
  left: 0;
  top: 2px;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  background: var(--panel);
  color: var(--ok);
}

.node[data-standing="not_applicable"] .marker {
  color: var(--muted);
}

.node[data-standing="missing"] .marker {
  color: var(--warn);
}

.card {
  min-width: 0;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 8px 10px;
  background: var(--panel);
}

.node[data-standing="missing"] .card {
  border-color: var(--warn-line);
  background: var(--warn-w);
}

.node[data-standing="not_applicable"] .card {
  background: var(--panel-2);
}

.nodeHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.nodeLabel {
  margin: 0;
  font-size: var(--t-min);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-2);
  font-weight: 700;
}

.standing {
  font-size: var(--t-min);
  font-weight: 700;
  color: var(--ok);
}

.node[data-standing="not_applicable"] .standing {
  color: var(--muted);
}

.node[data-standing="missing"] .standing {
  color: var(--warn);
}

.reason {
  margin: 4px 0 0;
  font-size: var(--t-min);
  line-height: 1.45;
  color: var(--ink-2);
  overflow-wrap: anywhere;
}

.node[data-standing="missing"] .reason {
  color: var(--warn);
}

.links {
  list-style: none;
  margin: 6px 0 0;
  padding: 6px 0 0;
  border-top: 1px dashed var(--line);
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
}

.linkItem {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--t-min);
  color: var(--muted);
}

.linkItem[data-standing="missing"] {
  color: var(--warn);
  font-weight: 700;
}

/* The node an evidence-meter click asked for. A rule and a wash, so it is seen without colour alone. */
.node[data-focused="true"] > .card {
  border-color: var(--accent-line);
  box-shadow: 0 0 0 2px var(--accent-line);
}
